import { render, staticRenderFns } from "./noteTemplateEditor.vue?vue&type=template&id=4fd0bfb2&"
import script from "./noteTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./noteTemplateEditor.vue?vue&type=script&lang=js&"
import style0 from "./noteTemplateEditor.vue?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports